import $ from "jquery";
import { openLightbox } from "./photoswipe";

const swipeTreshold = { x: 30, y: 30 };

const gallery = (elem) => {
  const $prev = elem.find(".gallery__button--prev");
  const $next = elem.find(".gallery__button--next");
  const $indicatorDots = elem.find(".gallery__dot");
  const $galleryItems = elem.find("a.gallery__item");

  const data = {
    item: 0,
    count: elem.find(".gallery__item").length,
    startMousePos: { x: -1, y: -1 },
    endMousePos: { x: -1, y: -1 },
  };

  $prev.off("click");
  $prev.on("click", () => prevImage(elem, data));

  $next.off("click");
  $next.on("click", () => nextImage(elem, data));

  $indicatorDots.off("click");
  $indicatorDots.on("click", function () {
    data.item = $(this).data("index");
    selectItem(elem, data);
  });

  elem.off("touchstart");
  elem.on("touchstart", (event) => onTouchStart(event, data));

  elem.off("touchend");
  elem.on("touchend", (event) => onTouchEnd(elem, event, data));

  $galleryItems.off("click");
  $galleryItems.on("click", function (event) {
    event.preventDefault();
    const $thisEl = $(this);

    let items = [];

    $galleryItems.each(function (i) {
      const $thisEl = $(this);

      const item = {
        src: $thisEl.attr("href"),
        title: $thisEl.attr("title"),
        w: 0,
        h: 0,
      };

      items.push(item);
      $thisEl.data("data-pswp-uid", i + 1);
    });

    const index = $thisEl.data("data-pswp-uid") - 1;

    openLightbox(items, index);
  });
};

const indicator = (element, data) => {
  element.find(".gallery__dot--active").removeClass("gallery__dot--active");
  element
    .find(`.gallery__dot[data-index="${data.item}"]`)
    .addClass("gallery__dot--active");
};

const prevImage = (element, data) => {
  data.item--;
  if (data.item < 0) {
    data.item = data.count - 1;
  }
  selectItem(element, data);
};

const nextImage = (element, data) => {
  data.item++;
  if (data.item >= data.count) {
    data.item = 0;
  }
  selectItem(element, data);
};

const selectItem = (element, data) => {
  const $activeItem = element.find(".gallery__item--active");

  $activeItem.length && $activeItem.removeClass("gallery__item--active");

  element
    .find(`.gallery__item[data-index="${data.item}"]`)
    .addClass("gallery__item--active");

  indicator(element, data);
};

const onTouchStart = (event, data) => {
  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.startMousePos.x = touch.pageX;
  data.startMousePos.y = touch.pageY;
};

const onTouchEnd = (element, event, data) => {
  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.endMousePos.x = touch.pageX;
  data.endMousePos.y = touch.pageY;

  const mousePosDiff = {
    x: data.startMousePos.x - data.endMousePos.x,
    y: data.startMousePos.y - data.endMousePos.y,
  };

  data.startMousePos = { x: -1, y: -1 };
  data.endMousePos = { x: -1, y: -1 };

  if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
    mousePosDiff.x > 0 ? nextImage(element, data) : prevImage(element, data);
  }
};

export const reloadScriptGallery = () => {
  const $elem = $(".gallery");

  $elem.each(function () {
    gallery($(this));
  });
};
reloadScriptGallery();
